// extracted by mini-css-extract-plugin
export default {"carouselWrapper":"HB-z","heading":"IB-z","cardOverride":"JB-z"};